import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/inventory-items', data)
    .then(response => response.data)
}

function update(data, id) {
  return axios.patch(`/inventory-items/${id}`, data)
    .then(response => response.data)
}

export default {
  fetch(params) {
    return axios.get('/inventory-items', { params: params })
      .then(response => response.data)
  },
  save(data, id) {
    return id ? update(data, id) : store(data)
  },
  issue(itemId, amount, staffId) {
    return axios.post('/inventory-items/issue', {
      staff_id: staffId,
      inventory_item_id: itemId,
      amount: amount
    }).then(response => response.data)
  },
  revokeIssued(data) {
    return axios.post('/inventory-items/revoke', data).then(response => response.data)
  },
  addToStock(itemId, amount, note) {
    return axios.post('/inventory-items/add-to-stock', {
      inventory_item_id: itemId,
      amount: amount,
      note: note
    }).then(response => response.data)
  },
  getIssuedItems(params) {
    return axios.get('/inventory-items/issued', { params: params })
      .then(response => response.data)
  },
  getIssuedItemsForMe(label) {
    return axios.get('/inventory-items/issued/me', {
      label: label || undefined
    }).then(response => response.data)
  },
  destroy(id) {
    return axios.delete(`/inventory-items/${id}`)
  }
}
